<template>
	<div class="left">
		<el-tabs v-model="active" style="padding: 0 20px;">
			<el-tab-pane v-for="item in tabsList" :label="item.name" :name="item.id" :key="item.id"></el-tab-pane>
		</el-tabs>

		<tableMode :orderList="list" :objectS="objectS" :active="active - 1" :total="page.total"></tableMode>

		<oPage v-if="page.total > page.limit" :current-page.sync="page.page" :page-size.sync="page.limit" style="margin-top: 16px;"
			:total="page.total" @current-change="getdata" />
	</div>
</template>
<script>
import { get } from '@/http/request'
import apis from '@/http/api'
import tableMode from './table.vue';
import oPage from '@/common/pc/oPage.vue'
export default {
	components: {
		tableMode,
		oPage,
	},
	props: {
		// title: {
		// 	type: String,
		// 	default: ''
		// },
		// account: {
		// 	type: Number,
		// 	default: 1
		// },
	},
	data() {
		return {
			// 1=充币记录，2=提币记录，3=借币数据，4=合约，5=AI，6=现货，7=投资组合，8=法币记录
			active: '0',
			tabsList: [],

			objectS: {},
			list: [],
			page: {
				page: 1,
				limit: 15,
				total: 10,
			},
		};
	},
	watch: {
		active() {
			this.getdata()
		}
	},
	methods: {

		init() {
			this.getTabsList()
		},
		getTabsList() {
			get(apis.orderTypeList, {
				showLoading: false
			}).then(res => {
				if (res.code != 1) return
				this.tabsList = res.data.map(item => {
					item.id = String(item.id)
					return item
				})
				if (this.tabsList.length > 0) {
					this.active = this.tabsList[0].id
				}
			})
		},
		getdata() {
			get(apis.getOrderData, {
				type: this.active,
				...this.page
			}).then(res => {
				if (res.code != 1) return
				this.list = res.data.list
				this.page.total = res.data.total || 0
				if (this.active == 3) {
					this.objectS.pecent = res.data.pecent//已还
					this.objectS.borrow = res.data.borrow//已借金额 
					this.objectS.repay = res.data.repay
				}
			})
		},
	},
};
</script>
<style lang="scss" scoped>
.left {
	border-radius: 12px;
	border: 2px solid #2c2c3e;
	min-height: 800px;
	padding: 20px 30px;
}
</style>